import { api } from '@/services/api/api'
import { endpoints } from '@/services/api/endpoints'
import {
  type CreateNotificationProps,
  type NotificationProps,
  type NotificationSource,
} from '@/services/types/notifications/mockNotifications'

export interface GetAllNotificationsResponse<
  T extends NotificationSource = NotificationSource.reviews,
> {
  notifications: Omit<NotificationProps<T>, 'recipients' | 'criteria' | 'filters' | 'channels'>[]
  totalNotifications: number
}

interface CreateNotificationResponse<T extends NotificationSource> {
  notification: NotificationProps<T>
}

interface EditNotificationResponse<T extends NotificationSource> {
  notification: NotificationProps<T>
}

interface GetNotificationByIdResponse<T extends NotificationSource = NotificationSource.reviews> {
  notification: NotificationProps<T>
}

export const notificationsService = {
  create<T extends NotificationSource>(data: CreateNotificationProps<T>) {
    return api.post<CreateNotificationResponse<T>>(endpoints.notifications.create, data)
  },
  editById<T extends NotificationSource>(id: string, data: Partial<CreateNotificationProps<T>>) {
    return api.patch<EditNotificationResponse<T>>(
      endpoints.notifications.edit.replace(':id', id),
      data,
    )
  },
  getAll<T extends NotificationSource>(notificationSource?: T) {
    const params = notificationSource ? { notificationSource } : undefined

    return api.get<GetAllNotificationsResponse<T>>(endpoints.notifications.getAll, {
      params,
    })
  },
  getById<T extends NotificationSource>(id: string) {
    return api.get<GetNotificationByIdResponse<T>>(
      endpoints.notifications.getById.replace(':id', id),
    )
  },
  deleteById(id: string) {
    return api.delete(endpoints.notifications.delete.replace(':id', id))
  },
}
